import {BaseAddressUnDeletable} from '../../../common/entities';


export class AlternativeLocation extends BaseAddressUnDeletable {
    name: string;
    companyId: number;
}
